import React from "react";
import { SvgCommon } from ".";
import { IconModel } from "../../models";

export const CountryIcon: React.FC<IconModel> = (props) => {
  return (
    <SvgCommon {...props}>
      <circle cx="5" cy="5" r="3.5" stroke={props.color} strokeWidth="2" />
      <circle cx="5" cy="15" r="3.5" stroke={props.color} strokeWidth="2" />
      <circle cx="15" cy="15" r="3.5" stroke={props.color} strokeWidth="2" />
      <mask id="path-4-inside-1" fill={props.color}>
        <rect x="10.5" y="0.5" width="9" height="9" rx="1" />
      </mask>
      <rect x="10.5" y="0.5" width="9" height="9" rx="1" stroke={props.color} strokeWidth="4" mask="url(#path-4-inside-1)" />
    </SvgCommon>
  );
};